import React from 'react';
import { graphql } from 'react-relay';

import QueryLookupRenderer from 'relay-query-lookup-renderer';

import useRelay from '@zego/hooks/useRelay';

import CarQuickEstimatesForm from '../forms/CarQuickEstimatesForm';

export default function StandaloneCarQuickEstimates(props) {
  const { environment } = useRelay();

  return (
    <QueryLookupRenderer
      lookup
      query={graphql`
        query StandaloneCarQuickEstimatesQuery {
          viewer {
            ...CarQuickEstimatesForm_viewer
          }
        }
      `}
      environment={environment}
      variables={{}}
      render={({ props: renderProps }) => {
        if (renderProps) {
          return <CarQuickEstimatesForm {...props} {...renderProps} />;
        }
        return null;
      }}
    />
  );
}
